<template>
  <div class="pusher">
    <!-- Page Contents -->
    <div class="ui inverted vertical center aligned segment">

      <div class="ui container">
        <div class="ui large secondary inverted pointing menu">
          <a class="toc item">
            <i class="sidebar icon"></i>
          </a>

          <div class="ui inverted secondary pointing menu tabs">
            <a class="item active" data-tab="data">
              Data
            </a>
            <a class="item" data-tab="activity">
              Activity
            </a>
            <a class="item" data-tab="settings">
              Settings
            </a>
          </div>

          <!-- <a href="/#home-section" class="item">About</a> -->
          <!-- <a href="/#data-section" class="item">Data</a> -->
          <!-- <a href="#pricing-section" class="active item">Pricing</a> -->
          <div class="right item">
            <!-- <a class="ui inverted button">Log in</a> -->
            <a @click.once="logout" class="ui inverted button">Log Out</a>
          </div>
        </div>
      </div>
    </div>
    <div class="ui container basic segment">

      <div class="ui tab active" data-tab="data">

        <h4 class="ui header">
          <i class="download icon"></i>
          <div class="content">
            Download
            <div class="ui inline dropdown">
              <div class="text" v-model="dataQuery_dateRange">{{dataQuery_dateRange}}</div>
              <i class="dropdown icon"></i>
              <div class="menu">
                <div class="header">Adjust time span</div>
                <div class="active item" data-text="latest" @click="dataQuery_dateRange = '1'">Latest</div>
                <div class="item" data-text="1 month" @click="dataQuery_dateRange = '4'">1 month</div>
                <div class="item" data-text="3 months" @click="dataQuery_dateRange = '12'">3 months</div>
                <div class="item" data-text="6 months" @click="dataQuery_dateRange = '26'">6 months</div>
                <div class="item" data-text="12 months" @click="dataQuery_dateRange = '52'">12 months</div>
                <div class="item" data-text="all" @click="dataQuery_dateRange = '999'">all</div>
              </div>
            </div>

            <div class="ui inline dropdown">
              <div class="text" v-model="dataQuery_dataType">{{dataQuery_dataType}}</div>
              <i class="dropdown icon"></i>
              <div class="menu">
                <div class="header">Change the data type</div>
                <div class="active item" data-text="listings" @click="dataQuery_dataType = 'listings'">listings</div>
                <div class="item" data-text="rentals" @click="dataQuery_dataType = 'rentals'">rentals</div>
                <div class="item" data-text="stats" @click="dataQuery_dataType = 'stats'">stats</div>
              </div>
            </div>

             data for

            <select :class="{'hidden': canSelectCounty}" id="filterCounties" class="ui search dropdown inline" multiple="" v-model="dataQuery_counties">
              <option value="">Location</option>
              <option @click="addCounty(c)" v-for="c in counties" :value="c">{{c}}</option>
            </select>

            <small @click="allCounties()" :class="{'hidden': !canSelectCounty || counties.length < 5}">(all)</small>

            <span :class="{'hidden': canSelectCounty}" id="entire-us">US</span>

            <div class="ui button primary" @click="getList()">GO</div>
          </div>
        </h4>

        <div class="ui hidden divider"></div>

        <div class="ui styled fluid accordion">
          <!-- <div class="title">
            <i class="dropdown icon"></i>
            via curl
          </div>
          <div class="content">
curl -L -u {{apiKey}}: https://d3bqsnp6f6s0m6.cloudfront.net/api/data?county={{dataQuery_counties[0]}} > {{dataQuery_counties[0]}}.csv.gz
# alternatively
curl -L -u {{apiKey}}: https://d3bqsnp6f6s0m6.cloudfront.net/api/data?county={{dataQuery_counties[0]}} | gunzip > {{dataQuery_counties[0]}}.csv

          </div> -->
          <!-- <div class="title">
            <i class="dropdown icon"></i>
            via python
          </div>
          <div class="content">
            <pre><code class="python">#!/bin/python
import requests

req = requests.get("https://d3bqsnp6f6s0m6.cloudfront.net/api/data?county=bozeman-mt", auth=("{{apiKey}}", ""))
req.text  # todo use stream=True and write to file / ungz
            </code></pre>
          </div> -->
          <div class="active title">
            <i class="dropdown icon"></i>
            via browser
          </div>
          <div class="active content">
            <div class="ui bottom attached segment">
              <table class="ui celled table">
                <thead>
                  <tr>
                    <th class=collapsing>Date</th>
                    <th>Location</th>
                    <th class=collapsing>Download</th>
                  </tr>
                </thead>
                <tr v-for="c in list">
                  <td class=collapsing>{{c.date}}</td>
                  <td>{{c.county}} - {{c.state}} - {{c.type}}</td>
                  <td class=collapsing>
                    <form method="get" :action="baseDataUrl">
                      <input type="hidden" name="county" :value="c.state_county" />
                      <input type="hidden" name="date" :value="c.date" />
                      <input type="hidden" name="type" :value="c.type" />
                      <button class="ui button"><i class="download icon"></i></button>
                    </form>
                  </td>
                </tr>
              </table>
              <br />
              <button v-if="list.length > 0" @click="downloadAll()" class="ui secondary button">
                Download all
              </button>

            </div>
          </div>
        </div>
        <!-- Tab Content !-->
      </div>

      <div class="ui tab" data-tab="activity">
        Last activity, downloads and logins etc.
        <table class="ui celled table">
          <thead>
            <tr>
              <th class="collapsing">Date</th>
              <th>Description</th>
              <th class="collapsing">Who</th>
            </tr>
          </thead>
          <tr v-for="a in activity">
            <td class="collapsing">{{a.date}}</td>
            <td>{{a.description}}</td>
            <td class="collapsing">{{a.who}}</td>
          </tr>
        </table>
      </div>

      <div class="ui tab" data-tab="settings">
        <div class="ui cards">
          <div class="card">
            <div class="content">
              <div class="header">{{user.name}}</div>
              <div class="meta">
                {{user.email}}
              </div>
              <div class="description">
                <div class="ui small feed">
                  <div class="content">
                    {{user.phone}}
                  </div>
                </div>
                <button class="ui basic mini button">
                  <i class="lock icon"></i>
                  Change Password
                </button>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="content">
              <div class="header">Credit Card</div>
              <div class="meta">(Stored in Stripe)</div>
              <div class="description">
                <div class="ui small feed">
                  <div class="content">
                    <div class="credit-card">
                      <!-- ending in 1234
                      expires 11/2018 -->
                      --
                    </div>
                  </div>
                </div>
                <button class="ui basic mini button">
                  <i class="credit card alternative icon"></i>
                  Update Card
                </button>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="content">
              <div class="header">Subscription:</div>
              <div class="meta">
                <i class="flag us"></i>

                {{user.plan}}
              </div>

              <div class="description">
                <div class="ui small feed">
                  <div class="content">
                    <div v-if="!countyPlan">3000 counties across the US</div>
                  </div>
                </div>
              </div>

              <h4 v-if="countyPlan" class="ui sub header">Counties</h4>
              <div v-if="countyPlan" v-for="c in counties" class="ui small feed">
                <div class="county">
                  <div class="content">
                    <div class="summary">
                       {{c}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="countyPlan" class="ui bottom attached button">
              <i class="add icon"></i>
              Add County
            </div>
          </div>
        </div>

        <h2 v-if="bills.length > 0">Billing History</h2>

        <table v-if="bills.length > 0" class="ui celled table">
          <thead>
            <tr>
              <th>Due Date</th>
              <th>Amount</th>
              <th class="collapsing">Paid</th>
              <th class="collapsing">Invoice</th>
            </tr>
          </thead>
          <tr v-for="b in bills" :class="{'positive': b.paid, 'negative': !b.paid}">
            <td>{{b.date}}</td>
            <td>{{b.amount}}</td>
            <td class="collapsing">
              <i class="icon" :class="{'checkmark': b.paid, 'close': !b.paid}"></i>
            </td>
            <td class="collapsing">
              <button class="ui button primary">
                <i class="file text outline icon"></i>
                Invoice
              </button>
            </td>
          </tr>
        </table>

        <br />
        <br />
        <br />

        <h4>
          Contact us: <a href="mailto:support@altosresearch.com">support@altosresearch.com</a>
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
var $ = window.$  // perhaps require('jQuery') would be better?
var hljs = window.hljs
import Vue from 'vue'  // Note: is there a new require syntax for this?

$.ajaxSetup({ xhrFields: { withCredentials: true } })

export default {
  name: 'signup',
  data () {
    return {
      msg: 'Welcome to List page',
      baseDataUrl: 'https://data.altos.re/api/data?',
      dataQuery_counties: [],
      dataQuery_dateRange: 'latest',
      dataQuery_dataType: 'listings',
      settings: {'user': {}},
      activity: [],
      bills: [],
      list: [],
      pythonCode: '#!/bin/bash python\nfor file_name in ["a", "b"]:\n    print(file_name)'
    }
  },
  computed: {
    counties: function () {
      var user = this.settings.user
      return user.counties ? user.counties.split(',') : []
    },
    user: function () {
      var that = this
      var user = this.settings.user
      console.log('here')
      if (user && user.countyPlan) {
        that.$forceUpdate()
        that.setAllUS(false)
        Vue.nextTick(function () {
          that.dataQuery_counties = that.user.counties.split(',').map(function (s) {
            // $('#filterCounties').dropdown('set selected', s)
            return s
          })
          that.$forceUpdate()
        })
      }
      return user
    },
    allUsOrCounties: function () {
      return this.dataQuery_allUS ? 'all of the us' : this.isDemo ? 'demo' : 'counties'
    },
    isDemo: function () {
      return this.user.plan === 'demo'
    },
    canSelectCounty: function () {
      this.$forceUpdate()
      // console.log('canSelectCounty')
      // console.log(!this.dataQuery_allUS && !this.isDemo)
      return !this.dataQuery_allUS && !this.isDemo
    },
    apiKey: function () {
      console.log(this.user)
      return this.user['api_key']
    },
    dataQuery_allUS: function () {
      console.log('plan', this.user.plan)
      var usAll = this.user.plan === 'us-all'
      if (usAll) {
        this.setAllUS(usAll)
      }
      return usAll
    },
    csvFiles: function () {
      var that = this
      if (that.dataQuery_allUS) {
        return [{'county': 'us-all', 'date': '2006-01-01'}]
      } else {
        return [].concat.apply(
          [],
          that.dataQuery_counties.map(function (c) {
            that.getList(c)
          })
        )
      }
    },
    countyPlan: function () {
      return this.user.plan && this.user.plan !== 'us-all'
    }
  },
  methods: {
    // https://stackoverflow.com/a/24782004/1240268
    chunk: function (arr, chunkSize) {
      var R = []
      for (var i = 0, len = arr.length; i < len; i += chunkSize) {
        R.push(arr.slice(i, i + chunkSize))
      }
      return R
    },
    fridaysFromDate: function (date) {
      console.log(d)
      var d = new Date(date)
      console.log(date)
      var until = new Date('2017-09-20')
      var result = []
      // aim is to get array of dates from then 'til now
      while (d < until) { d = new Date(d); d.setDate(d.getDate() + 7); result.push(d) }
      console.log(result)
      return result
    },
    setAllUS: function (flag) {
      var that = this
      this.dataQuery_allUS = flag

      that.$forceUpdate()
      Vue.nextTick(function () {
        if (that.dataQuery_allUS) {
          // whelp
          $('div:has(> #filterCounties)').hide()
          $('#entire-us').show()
        } else {
          $('div:has(> #filterCounties)').show()
          $('#filterCounties.ui.dropdown').dropdown()
          $('#entire-us').hide()
        }
        that.$forceUpdate()
      })
    },
    allCounties: function () {
      this.counties.map(function (s) {
        $('#filterCounties').dropdown('set selected', s)
      })
      this.$forceUpdate()
    },
    logout: function () {
      document.cookie = 'vx_session=;expires=Thu, 01 Jan 1970 00:00:01 GMT;'
      this.$router.replace({name: 'Login'})
    },
    printData: function () {
      console.log(this)
    },
    download: function (c) {
      console.log('Downloading', c)
    },
    addCounty: function (c) {
      console.log('Adding county', c)
    },
    downloadAll: function () {
      /**
       * Download a list of files.
       * @author speedplane
       * https://stackoverflow.com/a/29606450/1240268
       * (modified to download csvFiles)
       */
      console.log('oi')
      var that = this
      function downloadNext (i) {
        if (i >= that.list.length) {
          return
        }
        var a = document.createElement('a')
        a.href = that.dataUrl(that.list[i])
        a.target = '_parent'
        // Use a.download if available, it prevents plugins from opening.
        if ('download' in a) {
          // regex .replace(/^.*[\\\/]/, '') gets the filename
          // TODO use cleaner name? e.g. via function
          a.download = a.href.replace(/^.*[\\/]/, '')
        }
        // Add a to the doc for click to work.
        (document.body || document.documentElement).appendChild(a)
        if (a.click) {
          a.click() // The click method is supported by most browsers.
        } else {
          $(a).click() // Backup using jquery
        }
        // Delete the temporary link.
        a.parentNode.removeChild(a)
        // Download the next file with a small timeout. The timeout is necessary
        // for IE, which will otherwise only download the first file.
        setTimeout(function () { downloadNext(i + 1) }, 500)
      }
      // Initiate the first download.
      downloadNext(0)
    },
    dataUrl: function (c) {
      var url = this.baseDataUrl + 'county=' + c.state_county + '&date=' + c.date + '&type=' + c.type
      console.log(url)
      return url
    },
    getSettings: function () {
      var that = this
      return $.get('https://data.altos.re/api/settings').then(
        function (s) {
          that.settings = s
          that.dataQuery_dataType = that.settings.user.types.split(',')[0]
          that.$forceUpdate()
        },
        function () { that.logout(); console.log('error') }
      )
    },
    getActivity: function () {
      var that = this
      $.get('https://data.altos.re/api/activity').then(
        function (a) {
          a.map(function (e) {
            e.who = e['user-agent'].slice(0, 7)
            e.date = new Date(e['ts'] * 1000).toLocaleString()
            e.description = 'Access ' + e['path']
          })
          that.activity = a
        },
        function () { console.log('error') }
      )
    },
    getList: function (county) {
      this.$forceUpdate()

      // optionall pass county?
      var that = this
      var qs = '?type=' + that.dataQuery_dataType + '&range=' + this.dataQuery_dateRange
      that.list = []
      console.log('xxxx')

      // FIXME use a this var for this
      var selectedCounties = $('#filterCounties').parent().children('a').toArray().map(function (e) { return e.dataset.value })

      if (this.canSelectCounty) {
        if (selectedCounties.length > 0) {
          var countyChunked = this.chunk(selectedCounties, 5)
          for (var i = 0; i < countyChunked.length; i++) {
            var qsc = '&county=' + countyChunked[i].join(',')
            console.log('https://data.altos.re/api/list' + qs + qsc)
            $.get('https://data.altos.re/api/list' + qs + qsc).then(
              function (a) {
                that.list = that.list.concat(a)
              },
              function () { console.log('error') }
            )
          }
        }
      } else {
        console.log('yyyy')
        $.get('https://data.altos.re/api/list' + qs).then(
          function (a) {
            that.list = that.list.concat(a)
          },
          function () { console.log('error') }
        )
      }
      that.$forceUpdate()
    }
  },
  mounted: async function () {
    $('.ui.sidebar')
      .sidebar('attach events', '.toc.item')

    $('.ui.dropdown')
      .dropdown()

    // should be done each change (tab)?
    // $('#county-select.ui.dropdown')
    //  .dropdown({message: {noResults: 'No results found.'}})

    $('.tabs.menu .item')
      .tab()

    $('.ui.accordion')
      .accordion()

    $('pre code').each(function (i, block) {
      hljs.highlightBlock(block)
    })

    await this.getSettings()
    this.getActivity()
    this.setAllUS(!this.canSelectCounty)
    if (this.counties.length === 1) {
      this.allCounties()
    }
    this.getList()

    // verify that the user is signed in!
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.hidden {
  display: none !important;
}
.hidden * {
  display: none !important;
}


</style>



// WEBPACK FOOTER //
// Dashboard.vue?07acb95b